import { Fragment, useState } from 'react';
import { Line } from '../../themed/charts';

import Conditional from '../../common/conditional';
import HelideckDataAndGraphForm from '../../forms/helideckDataAndGraphForm';
import Pagination from '../../themed/pagination';
import Select from '../../themed/select/select';
import Table from '../../common/table';

import _ from 'lodash';
import css from './style.module.scss';

import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';
import * as dummyData from '../../../utils/data';
import * as toast from '../../../services/toastService';

interface HeledeckInspectionProps {
	data: any[];
	onDataChange: (item: any) => void;
	lineGraphData: any;
}

const HelideckInspection = (props: HeledeckInspectionProps) => {
	const [sortColumn, setSortColumn] = useState(initialSortColumn);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [pageSize, setPageSize] = useState<number>(3);

	const deleteItem = (item: any) => {
		const data: any[] = props.data.filter((d: any) => d.gridNo !== item.gridNo);
		props.onDataChange(data);
	};

	const getPageSizes = (): models.SelectOption[] => {
		return utils.getPageRange(20).map((p: number) => ({ id: p, name: p }));
	};

	const getPaginatedData = () => {
		let filtered = props.data;

		const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);
		const paginated = utils.paginate(sorted, currentPage, pageSize);

		return { totalCount: filtered.length, paginated };
	};

	const getActualTableColumns = () => {
		const tableColumns = dummyData.getHelideckFrictionTableColumns();

		const deleteColumn: models.Column = {
			path: '',
			label: 'Delete',
			content: (item: any) => (
				<button className={css['delete-item']} onClick={() => deleteItem(item)}>
					<i className="bi bi-trash"></i>
				</button>
			),
		};

		return [...tableColumns, deleteColumn];
	};

	const handlepageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const pageSize: number = +e.target.value;
		const actualPageSize: number = pageSize === 0 ? 1 : pageSize;

		setPageSize(actualPageSize);
	};

	const handleAddToData = (item: any): void => {
		const exists = props.data.find((d: any) => d.gridNo === item.gridNo);
		if (exists) return toast.error('Grid No has already been added');

		const newData = [...props.data, item];
		props.onDataChange(newData);
	};

	const paginatedData = getPaginatedData();

	return (
		<Fragment>
			<HelideckDataAndGraphForm onAdd={handleAddToData} />

			<Conditional isVisible={props.data.length > 0}>
				<Fragment>
					<div className="mt-3">
						<Table
							columns={getActualTableColumns()}
							data={paginatedData.paginated}
							sortColumn={sortColumn}
							onSort={setSortColumn}
							isFetching={false}
						/>

						<div className="d-flex justify-content-between align-items-center">
							<Select
								name="page-size"
								placeholder={'Showing (' + pageSize + 'rows)'}
								options={getPageSizes()}
								value={pageSize}
								onChange={handlepageSizeChange}
							/>

							<Pagination
								itemsCount={paginatedData.totalCount}
								pageSize={pageSize}
								currentPage={currentPage}
								onPageChange={(page) => setCurrentPage(page)}
							/>
						</div>
					</div>

					<Line chartData={props.lineGraphData} />
				</Fragment>
			</Conditional>
		</Fragment>
	);
};

export default HelideckInspection;

const initialSortColumn: models.SortColumn = {
	path: 'gridNo',
	order: 'desc',
};
